import Cookies from 'universal-cookie';

interface Coordinates {
  lat: number;
  long: number;
}

const getCoordinatesFromCookies = (): Coordinates | null => {
  const cookies = new Cookies();
  const lat = cookies.get('eigi-geolocated-lat');
  const long = cookies.get('eigi-geolocated-long');
  if (!lat || !long) return null;
  const parsedLat = Number(lat);
  const parsedLong = Number(long);
  if (Number.isNaN(parsedLat) || Number.isNaN(parsedLong)) return null;
  return { lat: parsedLat, long: parsedLong };
};

const COUNTRY_CODE_COOKIE = 'ctct-geolocated-country-code';
const PROVINCE_CODE_COOKIE = 'ctct-geolocated-province-code';
const STATE_CODE_COOKIE = 'ctct-geolocated-state-code';

interface GeolocatedAddressDefaults {
  countryCode: string;
  provinceCode: string;
  stateCode: string;
}

// Geolocation cookies can carry the sentinel "na" (not available); treat that as unset.
const normalizeCookie = (value: string | undefined): string | undefined =>
  value?.toLowerCase()?.trim() === 'na' ? undefined : value;

// Default country/state from the IP-geolocation cookies set upstream. Used to prefill
// address forms so most users don't have to pick their country/state manually.
// Falls back to US with no state when the cookies are absent.
const getGeolocatedAddressDefaults = (): GeolocatedAddressDefaults => {
  const cookies = new Cookies();
  const countryCode = normalizeCookie(cookies.get(COUNTRY_CODE_COOKIE)) ?? 'us';
  const provinceCode = normalizeCookie(cookies.get(PROVINCE_CODE_COOKIE)) ?? '';
  const stateCode =
    normalizeCookie(countryCode === 'ca' ? provinceCode : cookies.get(STATE_CODE_COOKIE)) ?? '';

  return { countryCode, provinceCode, stateCode };
};

export {
  type Coordinates,
  type GeolocatedAddressDefaults,
  getCoordinatesFromCookies,
  getGeolocatedAddressDefaults,
};
